import { Tab, TabProps, Tabs, Typography } from "@mui/material"
import { useEffect } from "react";
import { Link as RouterLink, Outlet, useLocation, useParams } from "react-router-dom"
import { AccountProvider } from "@features/tickets/shared/contexts/AccountContext";
import { useErrorBoundary } from "react-error-boundary";
import { handleErrorWithBoundary } from "@shared/lib/errors"
import { useTheme } from "@emotion/react";
import { useGetAccountByIdQuery } from "@features/tickets/api/accounts.api";
import { useTicketDetail } from "@features/tickets/shared/hooks";


interface LinkTabProps extends TabProps {
  path: string;
  selected?: string;
}

function LinkTab(props: LinkTabProps) {
  return (
    <Tab
      component={RouterLink}
      to={props.path}
      label={props.label}
      aria-current={props.selected ? 'page' : undefined}
      {...props}
    />
  );
}

const tabsData = [
  {
    label: "פרטי כרטיס",
    path: "",
  },
  {
    label: "תנועות",
    path: "journal-entries",
  },
];


function Bank() {

  const theme = useTheme();
  const location = useLocation();
  const { showBoundary } = useErrorBoundary();

  const currentIndex = tabsData.findIndex(tab => tab.path !== "" && location.pathname.includes(tab.path));
  const value = currentIndex !== -1 ? currentIndex : 0;

  const { id } = useParams();
  const { entity: bank, isLoading, error } = useTicketDetail(id, useGetAccountByIdQuery);

  useEffect(() => {
    if (error) {
      handleErrorWithBoundary(error, showBoundary);
    }
  }, [error, showBoundary]);

  if (isLoading || !bank) {
    return null;
  }

  return (
    <>
      <div>
        <Typography variant="h5" component="span">
          כרטיס בנק
        </Typography>

        <span>מס כרטיס: {bank.card_number}</span>
      </div>

      <Tabs
        dir='ltr'
        value={value}
        role="navigation"
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
        style={{ direction: "rtl", flexDirection: "row-reverse", backgroundColor: theme.colors.section_color, padding: 5, marginTop: 20 }}

      >
        {tabsData.map((tab, index) => (
          <LinkTab key={index} label={tab.label} path={tab.path} />
        ))}

      </Tabs>
      <AccountProvider account={bank}>
        <Outlet />
      </AccountProvider>
    </>
  );
}

export default Bank
